// Third-party
import { useRouter } from 'next/router';

// First-party
import { 
  If, 
  createPage
} from '@/common/util/templateHelpers';
import { useAuthenticated } from '@/common/hooks/authenticated';

// Component lib
import {
  Box, 
  Block, 
  Title, 
  LoaderFill, 
  Flex,
} from '@/common/components';
import { 
  Meta
} from '@/common/components/head';
import { 
  RegisterForm
} from '@/common/components/forms';

// Local
import style from './index.module.scss';
import FillScreenLayout from '@/layouts/FillScreenLayout';

export default createPage('RegisterPage', { style }, function RegisterPage ({ className }) {
  const { state } = useAuthenticated({
    authorizedRedirect: '/'
  });

  const router = useRouter();

  return (
    <FillScreenLayout>
      <Meta title='Create a new account' />

      {
        If(!state.ready, () => (
          <LoaderFill large />
        ))
          .Else(() => (
            <Flex center>
              <Flex className={className} directionColumn centerX centerY>
                <Flex directionColumn className='--textCenter'>
                  <Block>
                    <Title>Register</Title>
                    <RegisterForm captcha={false} onSuccess={() => router.push('/')} />
                  </Block>
                </Flex>
              </Flex>
            </Flex>
          ))
          .EndIf()
      }
    </FillScreenLayout>
  );
});
